export const DISRUPTION_PROTECTION_BANNER_TITLE =
  "Flight disruption assistance";
export const DISRUPTION_PROTECTION_BANNER_SUBTITLE =
  "We've got you covered if your flight gets delayed or canceled or if you miss a connection.";
export const DISRUPTION_MCP_BANNER_TITLE = "Rebook a connecting flight";
export const DISRUPTION_MCP_BANNER_SUBTITLE =
  "We've got you covered if your flight gets delayed or canceled and you miss a connection on route to your destination.";
